import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FiUpload } from 'react-icons/fi';
import { setSelectedFile, uploadTile } from 'store/slices/offlineTilesSlice';
import Load from 'components/Load/Load';
import * as S from './styles';

export default function UploadSection() {
	const dispatch = useDispatch();
	const inputRef = useRef(null);

	const [invalidFormat, setInvalidFormat] = useState(false);

	const { selectedFile, uploading } = useSelector((state) => state.offlineTiles);

	const handleFileChange = (e) => {
		const file = e.target.files[0];
		if (file) {
			const validExtensions = ['.tif', '.tiff', '.pdf'];
			const fileExtension = `.${file.name.split('.').pop().toLowerCase()}`;

			if (validExtensions.includes(fileExtension)) {
				setInvalidFormat(false);
				dispatch(setSelectedFile(file));
			} else {
				setInvalidFormat(true);
				e.target.value = ''; // limpa o input
			}
		}
	};

	const clearInputFile = () => {
		// limpa input
		if (inputRef.current) {
			inputRef.current.value = '';
		}
	};

	const handleUploadClick = () => {
		clearInputFile();
		inputRef.current?.click();
	};

	const handleSubmit = async () => {
		if (!selectedFile) return;

		try {
			await dispatch(uploadTile(selectedFile)).unwrap();

			clearInputFile();
		} catch (err) {
			// mantém o arquivo se falhar
			console.error(err);
		}
	};

	return (
		<S.Container>
			<input
				type="file"
				ref={inputRef}
				onChange={handleFileChange}
				accept=".tif,.tiff,.pdf"
				style={{ display: 'none' }}
			/>
			{invalidFormat && <S.InvalidFormat>Formato inválido. Use .tif, .tiff ou .pdf</S.InvalidFormat>}
			{selectedFile && <S.FileName>{selectedFile.name}</S.FileName>}
			<S.Buttons>
				<S.UploadButton type="button" onClick={handleUploadClick} disabled={uploading}>
					<FiUpload />
					<span>Upload</span>
				</S.UploadButton>

				<S.SubmitButton type="button" onClick={handleSubmit} disabled={!selectedFile || uploading}>
					{uploading ? <Load /> : 'ENVIAR'}
				</S.SubmitButton>
			</S.Buttons>
		</S.Container>
	);
}
